import React from 'react';

import styles from './FieldsListItem.pcss';

export interface ProfileAndSecurityFieldsListItemProps {
  readonly icon: React.ReactElement,
  readonly title: string,
  readonly value?: string,
}

export const ProfileAndSecurityFieldsListItem: React.FC<ProfileAndSecurityFieldsListItemProps> = (
  { icon, title, value },
) => (
  <div className={styles.listItem}>
    <icon.type {...icon.props} className={styles.icon} />
    <div className={styles.details}>
      <span className={styles.label}>{title}</span>
      <span className={styles.value}>{value}</span>
    </div>
  </div>
);
